import { Box } from '@mui/material';
import { ReactNode } from 'react';

function relativeLuminance(hex: string): number {
  const h = hex.replace('#', '').slice(0, 6);
  if (h.length < 6) return 0;
  const channels = [0, 2, 4].map((i) => {
    const c = parseInt(h.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
}

export function IconTile({
  children,
  color,
  size = 30,
}: {
  children: ReactNode;
  color: string;
  size?: number;
}) {
  // Pick glyph color for ≥4.5:1 vs tile fill, independent of app theme text tokens.
  const fg = relativeLuminance(color) > 0.183 ? '#111111' : '#FFFFFF';

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '8px',
        bgcolor: color,
        color: fg,
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        boxShadow: 'inset 0 -1px 0 rgba(0,0,0,0.08)',
        '& svg': { fontSize: size * 0.55 },
      }}
    >
      {children}
    </Box>
  );
}

export default IconTile;
